module.exports = __webpack_public_path__ + "img/06.f5c3d7dd.jpg";